import React, { useContext, useEffect, useState } from 'react'
import PageWrapper from "../../components/pageComponents/PageWrapper";
import PageHeader from "../../components/pageHeader/PageHeader";
import TableCampanaBonoTutoria from "./TableBonoTutoria";
import { descargarReporteSolicitudesBonoTutoria, eliminarSolicitudBonoTutoria, getAllAreasAPI, getAllCampanasAPI, getAllCargosAPI, getAllDepartamentosRegionesAPI, getAllEstadosAPI, getAllSedesAPI, getCampanasBonoTutoriaAPI, getCampanasBonoTutoriaOptionsAPI, getLineamientosCampanaBonoTutoriaAPI, getListaSolicitudesBeneficiosAPI, getSolicitudesByCampanaBonoTutoriaAPI } from '../../consumers/backendApisUrls';
import { useManageGetRequest } from '../../hooks/useManageGetRequest/useManageGetRequest';
import { initialAllOptionPromises, isNullOrUndefinded, jsonNoEstaVacio, updateFiltersWithExtraData, usuarioLogueadoTieneAlgunoDeLosSiguientesRoles } from '../../helper/utils';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import PageButtons from '../../components/pageComponents/PageButtons';
import { NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Select from "react-select";
import SearchContainer from '../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import TableBonoTutoria from './TableBonoTutoria';
import { useManagePostRequest } from '../../hooks/useManagePostRequest/useManagePostRequest';
import ModalEnabled from '../../components/modalComponents/ModalEnabled';
import CrearSolicitudBonoTutoria from './modales/Solicitudes/CrearSolicitudBonoTutoria';
import { useGenerarDescargarEliminarArchivo } from '../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo';
import { ROLES } from '../../constants/hardCodedConstants';
import { AuthContext } from '../../hooks/context/authContext';
const INIT_KEYS = {
    NombreCampana: "NombreCampana",
    FechaIngresoTrabajo: "FechaIngresoTrabajo",
    Region: "Region",
    Cargo: "Cargo",
    CampanaBonoTutoria: "CampanaBonoTutoria",
    FechaInicioCampana: "FechaInicioCampana",
    FechaFinCampana: "FechaFinCampana",
    FechaInicioTutoria: "FechaTutorFin",
    FechaFinTutoria: "FechaFinTutoria",
    LineamientoFile: "LineamientoFile",
    IdEmpleado: "IdEmpleado",
    FechaTutorInicio: "FechaTutorInicio",
    FechaTutorFin: "FechaTutorFin",
    EstadoRegistro: "EstadoRegistro",
    MontoProporcional: "MontoProporcional",
    NombreEmpleado: "NombreEmpleado",
    MotivoRechazo: "MotivoRechazo",
    EstadoEmpleado: "EstadoEmpleado"
};

const INIT_FILTROS = {
    IdsCargos: "IdsCargos",
    IdsAreas: "IdsAreas",
    IdsSedes: "IdsSedes",
    IdsEstadosSolicitud: "IdsEstadosSolicitud"
};
const AdminGestionBonoTutoria = () => {
    const [formValues, setFormValues] = useState({ Items: [], ExtraData: {}, filters: [], selectedFilters: {} });
    const [modalEnabled, setModalEnabled] = useState({ isEnable: false, component: React.Fragment });
    const [paginator, setPaginator] = useState({ CurrentPage: 1 });
    const [allFilters, setAllFilters] = useState([]);
    const [executeManageGet] = useManageGetRequest();
    const [executeManagePost] = useManagePostRequest();
    const [executeGet] = useGetRequest();
    const [allCampanasOptions, setAllCampanasOptions] = useState([]);
    const [selectedCampana, setSelectedCampana] = useState();
    const [searchCriteria, setSearchCriteria] = useState("");
    const [infoCampana, setInfoCampana] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [downloadAndDelete] = useGenerarDescargarEliminarArchivo();
    const { state } = useContext(AuthContext);
    const [rolCompensaciones, setRolCompensaciones] = useState();
    const [rolAdminSede, setRolAdminSede] = useState();
    const [rolCoordinadorGDH, setRolCoordinadorGDH] = useState();

    const initialPromises = () => {
        const response = executeGet(getAllEstadosAPI());

        return [
            executeGet(getAllCargosAPI()),
            executeGet(getAllDepartamentosRegionesAPI()),
            executeGet(getAllSedesAPI()),
            response
        ];
    }
    const init = async () => {
        setRolAdminSede(usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.SupervisorTutoria.id]));
        setRolCompensaciones(usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.Compensaciones.id]));
        setRolCoordinadorGDH(usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.CoodinadorGDH.id]))

        setIsLoading(true);
        try {
            await getAllCampanasOptions();
            await initialAllOptionPromises(initialPromises, Object.values(INIT_FILTROS), setAllFilters);
            await manageSearch();
            setIsLoading(false)
             if (formValues.filters.length === 0) {
                 jsonNoEstaVacio(formValues.ExtraData) &&
                     updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
             } 
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        init();
    }, [])

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({ ...lastData, filters: res }))
    }

    useEffect(() => {
        if (allFilters.length > 0) {
            updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
        }
    }, [allFilters]);

    const manageSearch = async () => {
        if (selectedCampana?.value > 0 && !isNullOrUndefinded(selectedCampana?.value)) {
            setIsLoading(true);
            try {
                await executeManagePost(getSolicitudesByCampanaBonoTutoriaAPI(), getPayload(), successManageSearchCallback)
                await executeManageGet(getLineamientosCampanaBonoTutoriaAPI(selectedCampana.value), (res) => setInfoCampana(res?.data))
            }
            catch (error) {

            }
            finally {
                setIsLoading(false);
            }
        }
    }
    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            IdCampanaBonoTutoria: selectedCampana?.value,
            ...formValues.selectedFilters
        }
    }

    const successManageSearchCallback = ({ data }) => {
        const { Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage } = data;
        setFormValues(lastData => ({ ...lastData, Items, ExtraData }));
        setPaginator({ TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage });
    }

    const handleCleanSearch = () => {
        setFormValues({ ...formValues, selectedFilters: null });
    }

    const getAllCampanasOptions = async () => {
        const api = getCampanasBonoTutoriaOptionsAPI();
        await executeManageGet(api, (res) => successGetAllCampanasCallback(res), false)
    }

    const successGetAllCampanasCallback = ({ data }) => {
        const items = data.map(o => ({ value: o.Value, label: o.Text }));
        const primerOpcion =
            { value: 0, label: "Seleccionar una Campaña" };
        items.unshift(primerOpcion);
        setAllCampanasOptions(items);
        if (items.length > 0) {
            setSelectedCampana(items[0]);
        }
    }

    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters, selectedCampana])

    const handleDownloadReporte = async () => {
        const api = descargarReporteSolicitudesBonoTutoria();
        let payload = getPayloadReporte();
        await downloadAndDelete(api, payload);
    }

    const getPayloadReporte = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            IdCampanaBonoTutoria: selectedCampana?.value
        }
    }

    const eliminar = async function (IdSolicitudBonoTutoria) {
        let payload = {
            "IdSolicitudBonoTutoria": IdSolicitudBonoTutoria
        }
        await executeManagePost(eliminarSolicitudBonoTutoria(), payload, manageSearch)
    }


    return (
        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />
            <PageHeader title="Gestión de Bono de tutoria" />
            <SelectCampanas items={allCampanasOptions} selectedItem={selectedCampana} setSelectedItem={setSelectedCampana} />
            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                <PageButtons>
                    {selectedCampana?.value > 0 && !isNullOrUndefinded(selectedCampana?.value) && <button className="generic-button-buscador" type="button" onClick={handleDownloadReporte}>
                        Descargar Excel
                    </button>}
                    {(selectedCampana?.value > 0 || rolCompensaciones) && <NavDropdown id={"navDropdown-configuracion-faltas"}
                        className=""
                        title={<span className="align-items-center p-2 ml-2"
                            style={{ backgroundColor: 'gray', borderRadius: '50%' }}
                            onClick={() => {
                            }}
                        >
                            <FontAwesomeIcon icon='cog' size="lg" className="hand-pointer white"
                                style={{ color: 'white' }}
                                title="Configurar" />
                        </span>}>
                        {rolCompensaciones && <Link
                            to="/gestionBonoTutoria/AdminListarCampanasBonoTutoria"
                            className="dropdown-item">
                            Configurar Campanas
                        </Link>}
                        {selectedCampana?.value > 0 && !isNullOrUndefinded(selectedCampana?.value) && <Link className="dropdown-item"
                            onClick={(e) => {
                                e.preventDefault()
                                window.open(infoCampana?.LineamientosUrl, '_blank');
                            }}>Ver Lineamientos
                        </Link>}
                        {selectedCampana?.value > 0 && (rolAdminSede || rolCompensaciones) && infoCampana?.EstadoCampana != 7 && <Link className="dropdown-item"
                            onClick={() => {
                                setModalEnabled({
                                    isEnable: true,
                                    component: CrearSolicitudBonoTutoria,
                                    data: { DataCampanaBonoTutoria: selectedCampana, fechasTutoria: infoCampana }
                                })
                            }
                            }>Agregar Registro
                        </Link>}
                    </NavDropdown>}
                </PageButtons>
            </SearchContainer>

            <TableBonoTutoria
                formValues={formValues}
                setFormValues={setFormValues}
                extraData={formValues.ExtraData}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                fechasTutoria={infoCampana}
                eliminar={eliminar}
                keys_filtros={INIT_FILTROS} />
        </PageWrapper>
    );
}
export default AdminGestionBonoTutoria;

const SelectCampanas = ({ items, selectedItem, setSelectedItem }) => (
    <div className='col-sm-4 mt-2 ml-2'>
        <Select
            placeholder="Seleccionar Campañas"
            options={items}
            value={selectedItem}
            onChange={(res) => setSelectedItem({ ...res })}
        />
    </div>
)
